(function () {
  'use strict';

  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function num(cs, name, def) {
    var v = parseFloat(cs.getPropertyValue(name));
    return isNaN(v) ? def : v;
  }

  /* El tema hace scroll dentro de .page-wrapper en escritorio y en la ventana en móvil. */
  function scrollParent(el) {
    var p = el.parentElement;
    while (p && p !== document.body && p !== document.documentElement) {
      var oy = getComputedStyle(p).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && p.scrollHeight > p.clientHeight + 1) return p;
      p = p.parentElement;
    }
    return null;
  }

  function init(root) {
    if (!root || root._pf) return;
    root._pf = true;

    var track = root.querySelector('.pf__track');
    var stage = root.querySelector('.pf__stage');
    var cards = [].slice.call(root.querySelectorAll('.pf__card'));
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!track || !stage || !cards.length) return;

    var P = {};
    var raf = 0;

    function readParams() {
      var cs = getComputedStyle(root);
      P.start = num(cs, '--pf-start', 0);
      P.step = num(cs, '--pf-step', 45);
      P.y = num(cs, '--pf-y', 22);
      P.turns = num(cs, '--pf-turns', 1);
    }

    function progress() {
      var sp = scrollParent(root);
      var base = sp ? sp.getBoundingClientRect().top : 0;
      var r = track.getBoundingClientRect();
      var total = r.height - stage.getBoundingClientRect().height;
      if (total <= 0) return 0;
      return clamp((base - r.top) / total, 0, 1);
    }

    /* Molino: todos los posters comparten eje vertical y giran juntos formando una hélice. */
    function render() {
      raf = 0;
      if (reduce.matches) return;
      var n = cards.length;
      var rot = progress() * P.turns * 360;
      for (var i = 0; i < n; i++) {
        var yy = (i - (n - 1) / 2) * P.y;
        var ang = P.start + i * P.step + rot;
        cards[i].style.transform = 'translate(-100%, -50%) translateY(' + yy + '%) rotateY(' + ang + 'deg)';
      }
    }

    function request() { if (!raf) raf = requestAnimationFrame(render); }
    function refresh() { readParams(); request(); }

    window.addEventListener('scroll', request, { passive: true, capture: true });
    window.addEventListener('resize', refresh);
    window.addEventListener('load', refresh);

    if (reduce.addEventListener) reduce.addEventListener('change', function () {
      if (reduce.matches) cards.forEach(function (c) { c.style.transform = ''; });
      else refresh();
    });

    root.addEventListener('pf:select', function (e) {
      var idx = e.detail && e.detail.index;
      if (idx == null || cards.length < 2) return;
      /* Lleva el poster elegido al frente: busca el progreso en el que su ángulo es el más frontal */
      var n = cards.length;
      var turnsDeg = P.turns * 360;
      var target = 0, best = 1e9;
      for (var k = 0; k <= 200; k++) {
        var pr = k / 200;
        var a = (((P.start + idx * P.step + pr * turnsDeg) % 360) + 360) % 360;
        var d = Math.min(a, 360 - a);
        if (d < best) { best = d; target = pr; }
      }
      var sp = scrollParent(root);
      var base = sp ? sp.getBoundingClientRect().top : 0;
      var r = track.getBoundingClientRect();
      var total = r.height - stage.getBoundingClientRect().height;
      var delta = (r.top - base) + total * target;
      if (sp) sp.scrollTo({ top: sp.scrollTop + delta, behavior: 'smooth' });
      else window.scrollTo({ top: window.scrollY + delta, behavior: 'smooth' });
    });

    refresh();
    setTimeout(refresh, 300);
  }

  function initAll(scope) {
    [].slice.call((scope || document).querySelectorAll('[data-pf]')).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('.pf__card') : null;
    if (!card) return;
    var root = card.closest('[data-pf]');
    if (!root) return;
    var idx = parseInt(card.getAttribute('data-index'), 10);
    root.dispatchEvent(new CustomEvent('pf:select', { detail: { index: idx } }));
  });
})();